import { Store } from "@/store/store";
import MonitoringService from "../MonitoringService";
// import monitoring from "@/assets/jsons/monitoring.json";
import { dateTimeFormat } from "@/utils/time-formatter";
import errorManager from "@/modules/errors/error-services/error-manager";
import randomColor from "randomcolor";
import { watch } from "vue";
class GraphStore extends Store {
  data() {
    return {
      loading: false,
      id: "",
      name: "",
      filters: {
        rangeStart: null,
        rangeEnd: null,
      },

      interval: 300, //seconds
      values: [],
      table: { x: [], y: this.values },
      config: {
        data: {
          labels: [],
          datasets: [
            {
              label: this.name,
              color: (20, 0, 220, 0),
              data: [],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      },
      call: async () => {
        return await MonitoringService.getMetrics(
          this.state.id,
          this.state.filters.rangeStart,
          this.state.filters.rangeEnd
        ).catch((er) =>
        
          errorManager.manage(er, errorManager.case("TimeoutUpstream",()=>errorManager.deafaultReject(er)), errorManager.errorPageReject(er))
        );
      },
      buildGraph: () => {
        return;
      },
      map: () => {
        return [];
      },
    };
  }
  async init(_id, initTime, _name) {
    this.state.id = this.loadId(_id);
    this.state.name = _name;
    this.updateRange(initTime, initTime - 5 * 60 * 60);
    this.state.table.x = this.getTimeStamps(
      this.state.filters.rangeEnd,
      this.state.filters.rangeStart
    );
    if (!this.state.values.data || !this.state.values.data.length > 0) {
      this.state.loading = true;
      await this.state
        .call()
        .then((response) => {
          this.state.values = response.data;
          console.log(this.state.values);
          this.state.buildGraph(this.state.table);
          // this.state.config.data.datasets[0].backgroundColor
          this.beforeUpdateChart();
          this.state.loading = false;
        })
        .catch((error) => {
          this.state.loading = false;
          return errorManager.manage(error);
        });
    }
    watch(
      () => this.state.filters,
      (val) => {
        this.state.loading = true;

        this.state
          .call()
          .then((response) => {
            this.state.values = response.data;
            console.log(val);
            this.state.table.x = this.getTimeStamps(
              val.rangeEnd,
              val.rangeStart
            );
            this.state.buildGraph(this.state.table);
            this.beforeUpdateChart();
            this.state.loading = false;
            return;
          })
          .catch((error) => {
            this.state.loading = false;
            return errorManager.manage(error);
          });
      },
      { deep: true }
    );
    watch(
      () => this.state.interval,
      (val) => {
        this.state.loading = true;
        this.state.table.x = this.getTimeStamps(val.rangeEnd, val.rangeStart);
        this.state.buildGraph(this.state.table);
        this.beforeUpdateChart();
        this.state.loading = false;
        return;
      },
      { deep: true }
    );

    //add watch values to update graph
    //add watch filters to update graph
  }
  async initBar(_id, initTime) {
    this.state.values = {}
    this.state.buildGraph = (table) => {
      this.state.config = {
        data: {
          labels: table.x.map((t) => dateTimeFormat(t)),
          datasets: [
            {
              label: this.state.name,
              fill: false,
              backgroundColor: "#f87979",
              data: this.state.map(this.state.values),
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      };
    }
      (this.state.map = () => {
        if (this.state.values.measure && this.state.values.data) {
          const indexTimestamp = this.state.values.measure.findIndex(
            (m) => m == "timestamp"
          );
          const intervals = this.state.table.x;
          let totDataPerTimestamp = new Array(intervals.length);
          if (indexTimestamp > -1) {
            this.state.values.data.forEach((element) => {
              let timestamp = element[indexTimestamp];
              let position = intervals.findIndex(
                (t) => t <= timestamp && t + this.state.interval > timestamp
              );
              let point = Number(element[indexTimestamp + 1].replace(".", ""));
              if (typeof point == "number") {
                totDataPerTimestamp[position] = totDataPerTimestamp[position]
                  ? totDataPerTimestamp[position] + point
                  : point;
              }
            });
          }
          return totDataPerTimestamp.map((val) => val / this.state.interval);
        }
      });
    return Promise.resolve(
      this.init(_id, initTime, "Throughtput b/s").then(() => true)
    );
  }

  async initLine(_id, initTime, _vals) {
    this.state.values = {}
    this.state.buildGraph = () => {
      console.log("building")
      this.state.config = {
        data: {
          labels: this.state.values.data.map(x=>dateTimeFormat(x[0])),
          // labels: this.state.table.x.map((t) => dateTimeFormat(t)),
          datasets: [
            {
              showLine: false,
              label: this.state.name,
              fill: false,
              backgroundColor: "#f87979",
              // data:this.state.values.data.map((v)=>{return{x: (v[0]*1000),y:v[1]}})
              data: this.state.values.data.map(x=>x[1]),           
            },
          ],
        },
        // options: {
        //     scales: {
        //         x: {
        //             type: 'time',
        //             time: {
        //                 displayFormats: {
        //                     quarter: "'ddd, dd MMM yyyy HH':'mm':'ss 'GMT'",
        //                     // min: dateTimeFormat(this.state.filters.rangeStart*1000),
        //                     // max: dateTimeFormat(this.state.filters.rangeEnd*1000)
        //                 }
        //             }
        //         }
        //     },
        //   responsive: true,
        //   maintainAspectRatio: false,
        // },
      };
    }
      (this.state.map = () => {
        if (this.state.values.measure && this.state.values.data) {
          const indexTimestamp = this.state.values.measure.findIndex(
            (m) => m == "timestamp"
          );
          const intervals = this.state.table.x;
          let totDataPerTimestamp = new Array(intervals.length);
          if (indexTimestamp > -1) {
            this.state.values.data.forEach((element) => {
              let timestamp = element[indexTimestamp];
              let position = intervals.findIndex(
                (t) => t - this.state.interval < timestamp && t > timestamp
              );
              let point = Number(element[indexTimestamp + 1]);
              if (typeof point == "number") {
                totDataPerTimestamp[position] = totDataPerTimestamp[position]
                  ? totDataPerTimestamp[position] + point
                  : point;
              }
            });
          }
          return totDataPerTimestamp.map((val) => val);
        }
      });
    this.state.values = _vals ? _vals : {};
    return Promise.resolve(this.init(_id, initTime, "Byte Trasmission")).then(
      () => true
    );
  }

  getTimeStamps(_end, _start) {
    let timestamps = [];
    // this.updateRange(_end,_start)
    let end = _end ? _end : Math.floor(new Date().getTime() / 1000);
    let start = _start ? _start : end - 5 * 60 * 60;
    do {
      timestamps.push(start);
      start = start + this.state.interval;
    } while (start < end);
    //TODO see if i can filter labels
    this.state.labels = timestamps
      .filter((t, index) => index % Math.floor(timestamps.length / 5) === 0)
      .map((t) => new Date(t));
    return timestamps;
  }
  loadId(_id) {
    return _id ? _id : localStorage.getItem("baseStationId");
  }
  beforeUpdateChart() {
    // let idx = 0;

    for (const dataset of this.state.config.data.datasets) {
      if (!dataset.borderColor) {
        // const borderColor = [];
        // for (let i = 0; i < dataset.data.length; i++) {
        //   borderColor.push(pickColor(idx++));
        // }
        // dataset.borderColor = borderColor;
        let bgColor = randomColor({
          luminosity: "bright",
          hue: "blue",
          format: "hex",
        });

        // if (!dataset.backgroundColor) {
        dataset.backgroundColor = dataset.data.map(() => {
          // const alpha = Math.min(1, Math.max(0, 0.5));

          return bgColor;
        });
        // }
      }
    }
  }
  updateRange(end, start) {
    this.state.filters.rangeEnd = end;
    this.state.filters.rangeStart = start;
  }
}

export const barChartstore = new GraphStore("BAR_CHART_STATION");
export const lineChartstore = new GraphStore("SCATTER_CHART_STATION");

export function beforeUpdateChart(chartData) {
  let idx = 0;
  for (const dataset of chartData.datasets) {
    if (!dataset.borderColor) {
      const borderColor = [];
      for (let i = 0; i < dataset.data.length; i++) {
        borderColor.push(pickColor(idx++));
      }
      dataset.borderColor = borderColor;

      if (!dataset.backgroundColor) {
        dataset.backgroundColor = borderColor.map(() => {
          const alpha = Math.min(1, Math.max(0, 0.5));
          return pickColor(idx++) + alpha;
        });
      }
    }
  }
}

export function pickColor(idx) {
  const colors = [
    "#FF5252",
    "#339AF0",
    "#FDCB58",
    "#4CAF50",
    "#FF6B6B",
    "#5AB9EA",
    "#FF9F40",
    "#CDDC39",
    "#BB6BD9",
    "#3D85C6",
    "#009688",
    "#B39DDB",
  ];

  const colorIdx = idx % colors.length;
  const alphaIdx = 4 - Math.floor(idx / colors.length);

  const color = colors[colorIdx];
  const alpha = Math.min(1, Math.max(0, 0.2 * alphaIdx));

  const rgb = [
    parseInt(color.slice(1, 3), 16),
    parseInt(color.slice(3, 5), 16),
    parseInt(color.slice(5, 7), 16),
  ];

  return `rgba(${rgb.join(", ")}, ${alpha})`;
}
